<template><div><h1>国际化</h1>
<div class="warning">
<p>暂时只支持配合<code>vux-loader</code>使用。</p>
<p>如果你只需要默认的中文组件，那么你可以略过下面说明，只要启用<code>vux-ui</code>插件即可。</p>
</div>
<p>默认不配置此插件时，vux源码会按照默认语言<code>zh-CN</code>进行静态编译，和原来的使用没有明显不同。</p>
<p>详细请参照 <a router-link="/zh-CN/vux-loader?id=i18n" style="color:#42b983;">vux-loader的vux-i18n文档</a></p>
</div></template><script>
export default {
  head: {"title":"国际化 i18n | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// i18n-154.vue?47b4da04